// src/content/constants.ts
var LOCALES = ["en", "hi", "gu", "mr", "fr", "it", "es", "pt", "de", "ar"];
var AVAILABLE_LOCALES = ["en", "hi", "fr", "de", "es", "pt", "ar"];
var RTL_LOCALES = ["ar"];
var BASE_LOCALE = "en";

export { AVAILABLE_LOCALES, BASE_LOCALE, LOCALES, RTL_LOCALES };
//# sourceMappingURL=chunk-YQXGWEFO.js.map
//# sourceMappingURL=chunk-YQXGWEFO.js.map